import { PEDIDO_STATUS } from '../../constants/status-pedido';

export function filterStatusRetirada({ currentStatus, statusList }) {
    if (currentStatus === PEDIDO_STATUS.SEPARADO) {
        return statusList.filter(
            (iStatus) => iStatus.idStatusPedido !== PEDIDO_STATUS.EM_TRANSPORTE
        );
    }

    if (
        currentStatus === PEDIDO_STATUS.DISPONIVEL_RETIRADA ||
        currentStatus === PEDIDO_STATUS.FINALIZADO
    ) {
        return statusList.filter(
            (iStatus) =>
                iStatus.idStatusPedido !== PEDIDO_STATUS.SEPARADO &&
                iStatus.idStatusPedido !== PEDIDO_STATUS.EM_TRANSPORTE
        );
    }
}

export function filterStatusEntrega({ currentStatus, statusList }) {
    if (currentStatus === PEDIDO_STATUS.SEPARADO) {
        return statusList.filter(
            (iStatus) =>
                iStatus.idStatusPedido !== PEDIDO_STATUS.DISPONIVEL_RETIRADA
        );
    }

    if (
        currentStatus === PEDIDO_STATUS.EM_TRANSPORTE ||
        currentStatus === PEDIDO_STATUS.FINALIZADO
    ) {
        return statusList.filter(
            (iStatus) =>
                iStatus.idStatusPedido !== PEDIDO_STATUS.SEPARADO &&
                iStatus.idStatusPedido !== PEDIDO_STATUS.DISPONIVEL_RETIRADA
        );
    }
}
